module.exports = __webpack_public_path__ + "static/media/s-home_format_masterclass.02f7647e.jpg";